import { FACILITY_USER_ACCESS_MODE } from '@/constants/facilityUserAccessModes';

export const FACILITY_USER_FORM_ERRORS = Object.freeze({
  ORGANIZATION_REQUIRED: 'Please select an organization',
  ROLE_REQUIRED: 'Please select a role when using role-based permissions',
  ACCESS_MODE_REQUIRED: 'Please select a facility access mode',
  FACILITIES_REQUIRED: 'At least one facility must be selected',
  FACILITY_GROUPS_REQUIRED: 'Please select at least one facility group',
});

export const validateFacilityUserAccessSelection = ({
  permissionsType,
  selectedRoleId,
  selectedOrganization,
  accessMode,
  selectedFacilities = [],
  selectedFacilityGroupIds = [],
}) => {
  const errors = {};

  if (!selectedOrganization) {
    errors.organization = FACILITY_USER_FORM_ERRORS.ORGANIZATION_REQUIRED;
  }

  if (permissionsType === 'role' && !selectedRoleId) {
    errors.role = FACILITY_USER_FORM_ERRORS.ROLE_REQUIRED;
  }

  if (accessMode === FACILITY_USER_ACCESS_MODE.NONE) {
    errors.accessMode = FACILITY_USER_FORM_ERRORS.ACCESS_MODE_REQUIRED;
  }

  if (
    accessMode === FACILITY_USER_ACCESS_MODE.DIRECT_FACILITIES &&
    selectedFacilities.length === 0
  ) {
    errors.facilities = FACILITY_USER_FORM_ERRORS.FACILITIES_REQUIRED;
  }

  if (
    accessMode === FACILITY_USER_ACCESS_MODE.FACILITY_GROUPS &&
    selectedFacilityGroupIds.length === 0
  ) {
    errors.facility_groups = FACILITY_USER_FORM_ERRORS.FACILITY_GROUPS_REQUIRED;
  }

  return errors;
};
